import { Api } from 'lavva.exalushome';
import { DataFrame, Method, Status } from 'lavva.exalushome/build/js/DataFrame';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { ExalusConnectionService } from 'lavva.exalushome/build/js/Services/ExalusConnectionService';
import { ResponseResult } from 'lavva.exalushome/build/js/Services/FieldChangeResult';
import { IExalusConnectionService } from 'lavva.exalushome/build/js/Services/IExalusConnectionService';
import { GetParamsErrorCode } from '../../../ExtaLife';
import { IFirmwareService } from './IFirmwareService'

export class FirmwareService implements IFirmwareService {
    private _connection: IExalusConnectionService | null = null;
    public static readonly ServiceName: string = "FirmwareService";

    constructor() {
        this._connection = Api.Get<IExalusConnectionService>(ExalusConnectionService.ServiceName);
    }

    GetServiceName(): string {
        return FirmwareService.ServiceName;
    }

    async GetFirmwareVersionAsync(device: IDevice): Promise<FirmwareVersion | ResponseResult<GetParamsErrorCode>> {
        const result = await this._connection?.SendAndWaitForResponseAsync<FirmwareVersion>(new GetFirmwareVersion(device.Guid), 35000, false);

        if (result === null || result === undefined)
            return new ResponseResult(GetParamsErrorCode.UnknownError, `Failed to retrieve firmware version - unknow error.`);

        switch (result.Status) {
            case Status.OK:
                if (result.Data != null) {
                    const fv = new FirmwareVersion();
                    fv.Major = result.Data.Major;
                    fv.Minor = result.Data.Minor;
                    fv.Revision = result.Data.Revision;
                    fv.Build = result.Data.Build;
                    return fv;
                }
                break;
            case Status.Error:
                return new ResponseResult(GetParamsErrorCode.UnknownError, `Failed to retrieve firmware version - unknow error.`);
        }

        return new ResponseResult(GetParamsErrorCode.OtherError, `Failed to retrieve firmware version, response error: ${result.Status} data: ${result.Data}`);
    }
}

export class FirmwareVersion {
    Revision: number = 0;
    Build: number = 0;
    Minor: number = 0;
    Major: number = 0;

    ToString(): string {
        return `${this.Major}.${this.Minor}.${this.Build}.${this.Revision}`;
    }
}

class GetFirmwareVersion extends DataFrame<string> {
    constructor(data: string) {
        super();
        this.Resource = "/extalife/device/firmware/version/complete";
        this.Method = Method.Get;
        this.Data = data;
    }
}